module.exports = __webpack_public_path__ + "img/80.4e8dacdd.webp";